import React, { useEffect, useRef, useState } from 'react'
import DeviceTable from '../components/DeviceTable'
import { cancelToken, dMmm, get, getQueryParams, getXlsx, isEmpty } from '@fareye/utils'
import {
  DEVICE_CONFIG,
  HEADER_INFLECTION,
  initialState
} from '../../../config/constants'
import {
  Button,
  Card,
  Flex,
  Grid,
  Link,
  RenderControl,
  styled,
  toast,
  usePrevious
} from '@fareye/ui'
import DeviceModal from '../components/DeviceModal'
import HistoryModal from '../components/HistoryModal'
import FileUpload from '../components/FileUpload'
import { downloadToCSV } from '@fareye/common'

const CustomInput = styled.input`
  height: 16px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(179, 179, 179);
  border-radius: 4px;
  padding: 9px 13px;
  font-size: 16px;
  background: transparent;
  outline: none;
`
const CustomLink = styled(Link)`
  background: rgb(24, 144, 255);
  color: white;
`
export  function Devices() {
  const [device, setDevices] = React.useState(initialState)
  const[exportState,setExportState]=React.useState({
    isLoading:false
  })
  const [selectedDevice, setSelectedDevice] = React.useState({
    data: null,
    openHistoryModal: false,
    openEditModal: false
  })
  const [meta, setMeta] = React.useState({
    perPage: 20,
    count: 0,
    page: 1
  })
  const searchRef = useRef<HTMLInputElement>(null)
  const source = cancelToken().source()
  const [reloadDevice,setReloadDevice]=React.useState(0)
  const { devices ,exportDevice} = DEVICE_CONFIG
  const [consigner, setConsigner] = useState({
    consigners: [],
  })

  useEffect(() => {
    fetchDevices()
  }, [Number(meta.page)])

  useEffect(() => {
    if(reloadDevice){
      fetchDevices(false)
    }
  }, [reloadDevice])

  const fetchDevices = async (updateList=true) => {
    try {
      setDevices({ ...device, isLoading: true })
      const queryString = getQueryParams({ page_no: meta.page })
      const url = `${devices}?${queryString}`
      const {
        data: { data, meta: metaInfo , consigners}
      } = await get(url, source.token, HEADER_INFLECTION)
      const finalData: any = updateList?[...device.data, ...data]:data
      setDevices({
        ...device,
        data: finalData,
        isLoading: false,
        isSuccess: true,
        isError: false
      })
      setMeta(metaInfo)
      setConsigner(consigners)
    } catch (ex) {
      setDevices({
        ...device,
        isLoading: false,
        isSuccess: false,
        isError: true
      })
      console.error(ex)
    }
  }

  const searchVehicle = async () => {
    try {
      const inputVal = searchRef.current?.value
      let searchUrl = `${devices}/search?search=${inputVal}`
      const {
        data: { data, meta }
      } = await get(searchUrl, source.token, HEADER_INFLECTION)

      setDevices({
        ...device,
        data,
        isLoading: false,
        isSuccess: true,
        isError: false
      })
      setMeta(meta)
    } catch (ex) {
      setDevices({
        ...device,
        isLoading: false,
        isSuccess: false,
        isError: true
      })
      console.error(ex)
    }
  }

  const handleExport=async()=>{
   try {
    const apiUrl=exportDevice
    setExportState({isLoading:true})
    const response = await getXlsx(apiUrl, source.token)
    const { data } = response
    downloadToCSV({
      data,
      fileName: `GPSDeviceData${dMmm()}`,
      type: 'text/zip',
      extension: 'zip'
    })
    setExportState({isLoading:false})
  } catch (ex:any) {
    setExportState({isLoading:false})
    toast.error(('Something went wrong ....'))
    console.warn(ex)
  }
  }

  return (
    <Card>
      <Flex style={{ margin: '10px 10px 50px 10px' }} justifyContentSpaceBetween>
        <Grid gridTemplateColumns="1fr .5fr" gridGap="10px" alignItemsCenter>
          <CustomInput
            placeholder="Enter Imei or VehicleNo"
            type="text"
            ref={searchRef}
          />
          <Button variant="m primary" onClick={searchVehicle}>
            Search
          </Button>
        </Grid>
        <Grid gridTemplateColumns="repeat(4,1fr)" gridGap="16px">
          <Button
            variant="primary"
            onClick={() =>
              setSelectedDevice({ ...selectedDevice, openEditModal: true })
            }
          >
            Add Device
          </Button>
          <FileUpload  setReloadDevice={setReloadDevice}/>
          <CustomLink to="/sample_export.xlsx" target="_blank" download>
           Download Sample File
          </CustomLink>
          <Button variant='primary' isLoading={exportState.isLoading} disabled={exportState.isLoading} onClick={handleExport}>Export Data</Button>
        </Grid>
      </Flex>
      <RenderControl state={device}>
        <DeviceTable
          setSelectedDevice={setSelectedDevice}
          setDevices={setDevices}
          deviceData={device}
          meta={meta}
          setMeta={setMeta}
        />
      </RenderControl>
      {selectedDevice.openEditModal && (
        <DeviceModal
          selectedDevice={selectedDevice}
          setSelectedDevice={setSelectedDevice}
          setDevices={setDevices}
          consigners={consigner}
        />
      )}
      {selectedDevice.openHistoryModal && (
        <HistoryModal
          setSelectedDevice={setSelectedDevice}
          selectedDevice={selectedDevice}
          setDevices={setDevices}
          meta={meta}
          setMeta={setMeta}
        />
      )}
    </Card>
  )
}
